module.exports = __webpack_public_path__ + "img/gestures_en.fe22fb6.jpg";